__turbopack_context__.v({
  "modalContent": "FolderCreationModal-module__GOt92W__modalContent",
  "sharedCheckbox": "FolderCreationModal-module__GOt92W__sharedCheckbox",
});
